import { Box, BoxProps } from "@chakra-ui/react";
import { FaInstagram } from "react-icons/fa";

export const href = "https://www.instagram.com/myareahub";

export type Instagram_T = BoxProps;

export const Instagram = (props: Instagram_T) => {
  return (
    <Box as={FaInstagram} aria-label="Instagram" fill="instagram" {...props} />
  );
};
